import React from "react";
import styles from "./CardIcon.module.scss";
import cn from "classnames";
import LazyImage from "../LazyImage/LazyImage";

interface CardIconProps {
    title: string,
    text: string,
    image: string,
    className?: string | Array<keyof typeof styles>;
}

const CardIcon: React.FC<CardIconProps> = (
    {
        title,
        text,
        image,
        className
    }) => {
    return (
        <div className={cn(styles.cardIcon, Array.isArray(className)
            ? className.map(cls => styles[cls] || cls)
            : className)}
        >
            <div className={styles.cardIconRow}>
                <p className={styles.cardIconTitle}>{title}</p>
                <p className={styles.cardIconText}>{text}</p>
            </div>
            <div className={styles.cardIconImageWrap}>
                <LazyImage className={styles.cardIconImage} src={image} alt={title}/>
            </div>
        </div>
    )
}
export default CardIcon;